// components/GoogleLoginButton.js
import React from 'react';
import { API_BASE_URL } from '../config';
import './GoogleLoginButton.css';

const GoogleLoginButton = ({ text = "Continuer avec Google" }) => {
  
  const handleGoogleLogin = () => {
    console.log('🔐 Démarrage authentification Google...');
    console.log('🌐 URL Backend utilisée:', API_BASE_URL);
    
    const googleAuthUrl = `${API_BASE_URL}/auth/google`;
    console.log('🔗 URL OAuth complète:', googleAuthUrl);
    
    // 🔥 NOUVEAU : Détection tunnel Cloudflare ou mobile
    const isTunnel = API_BASE_URL.includes('trycloudflare.com');
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    console.log('🌐 Mode tunnel détecté?', isTunnel);
    console.log('📱 Mobile détecté?', isMobile);
    
    // 🔥 NOUVEAU : Si tunnel OU mobile → Redirection complète
    if (isTunnel || isMobile) {
      console.log('🔄 Redirection complète vers Google Auth');
      window.location.href = googleAuthUrl;
      return;
    }
    
    // ✅ Desktop localhost : Popup
    console.log('💻 Ouverture popup desktop');
    
    const width = 500;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    
    const popup = window.open(
      googleAuthUrl,
      'Google Login',
      `width=${width},height=${height},top=${top},left=${left}`
    );
    
    if (!popup) {
      console.error('❌ Popup bloquée par le navigateur');
      alert('Veuillez autoriser les popups pour vous connecter avec Google');
      window.location.href = googleAuthUrl; // 🔥 NOUVEAU : Fallback
      return;
    }
    
    window.addEventListener('message', handleAuthMessage);
    
    const popupCheck = setInterval(() => {
      try { // 🔥 NOUVEAU : Protection COOP
        if (popup.closed) {
          clearInterval(popupCheck);
          window.removeEventListener('message', handleAuthMessage);
          console.log('🔒 Popup OAuth fermée');
        }
      } catch (e) {
        clearInterval(popupCheck);
      }
    }, 500);
  };
  
  const handleAuthMessage = (event) => {
    console.log('📩 Message reçu de:', event.origin);
    console.log('📩 Données:', event.data);
    
    const allowedOrigins = [
      window.location.origin,
      'http://localhost:3000',
      'http://localhost:5000'
    ];
    
    if (process.env.REACT_APP_API_URL) {
      const backendOrigin = new URL(process.env.REACT_APP_API_URL).origin;
      allowedOrigins.push(backendOrigin);
    }
    
    if (!allowedOrigins.includes(event.origin)) {
      console.warn('⚠️ Message de origine non autorisée:', event.origin);
      return;
    }
    
    if (event.data.type === 'GOOGLE_AUTH_SUCCESS') {
      console.log('✅ Authentification Google réussie');
      
      localStorage.setItem('token', event.data.token);
      localStorage.setItem('user', JSON.stringify(event.data.user));
      
      window.location.href = '/dashboard';
    } else if (event.data.type === 'GOOGLE_AUTH_ERROR') {
      console.error('❌ Erreur authentification Google:', event.data.error);
      alert('Erreur lors de la connexion avec Google. Veuillez réessayer.');
    }
  };
  
  return (
    <button 
      onClick={handleGoogleLogin}
      className="google-login-button"
      type="button"
    >
      <svg className="google-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
      <span className="google-button-text">{text}</span>
    </button>
  );
};

export default GoogleLoginButton;